import { useContext } from 'react';
import { RadioButtonList } from '@interstate/components/RadioButtonList';
import type { FormRadioButtonListProps } from '../types';
import { FormContext } from './formContext';

export const FormRadioButtonList = ({ name, label, options, inline }: FormRadioButtonListProps) => {
    const { form, changeHandler } = useContext(FormContext);

    return (
        <RadioButtonList
            data-testid={`vehicle-input-${name}`}
            inline={inline}
            label={label}
            name={name}
            onChange={(ev) => changeHandler(name, ev.target.value as string)}
            options={options}
            value={form.values[name] as string}
        />
    );
};
